import ReactPlayer, { ReactPlayerProps } from 'react-player';
import { useAuthedMediaUrl } from '../../hooks/useAuthedMediaUrl';

interface AuthedVideoPlayerProps extends Omit<ReactPlayerProps, 'url'> {
    url: string;
}

/**
 * ReactPlayer wrapper for video served behind SL_cProxy's Bearer-auth (e.g.
 * /api/cproxy/v1/downloads/*) - a plain url string can't carry an Authorization header. Uses
 * its own component instance (not inlined in a .map() callback) specifically so
 * useAuthedMediaUrl's hook call stays valid when rendering a list of videos. See AuthedImage /
 * useAuthedMediaUrl / TASKS.md.
 */
export const AuthedVideoPlayer = ({ url, ...playerProps }: AuthedVideoPlayerProps) => {
    const blobUrl = useAuthedMediaUrl(url);
    if (!blobUrl) return null;
    return <ReactPlayer url={blobUrl} {...playerProps} />;
};
